import { Trans, useTranslation } from 'react-i18next';

import Typography from '../../../../../../components/Typography';
import { i18nNS } from '../../../../../../i18n';
import { ViewErrorsLink } from './styles';
import ViewErrorsDialog, { ViewErrorsDialogProps } from './ViewErrorsDialog';
import usePublishHelper, { UsePublishHelper } from './vm';

export interface PublishHelperProps extends UsePublishHelper, Pick<ViewErrorsDialogProps, 'errors'> {}

const PublishHelper = ({ errors, ...vmProps }: PublishHelperProps) => {
  const { t } = useTranslation([i18nNS.POLL]);

  const { isPollInvalid, color, message, isViewErrorsDialogOpen, handleCloseViewErrorsDialog, handleClickViewErrors } =
    usePublishHelper(vmProps);

  return (
    <>
      <Typography variant="textXsBold" color={color}>
        {isPollInvalid ? (
          <Trans t={t} ns={i18nNS.POLL} i18nKey="poll_has_errors_and_cannot_be_published_view_errors">
            Poll has errors and cannot be published (
            <ViewErrorsLink color="error" onClick={handleClickViewErrors}>
              View errors
            </ViewErrorsLink>
            )
          </Trans>
        ) : (
          message
        )}
      </Typography>
      <ViewErrorsDialog open={isViewErrorsDialogOpen} onClose={handleCloseViewErrorsDialog} errors={errors} />
    </>
  );
};

export default PublishHelper;
